import React from "react";
import logo from "../../../../assets/img/layout/navlogo.png";
import DevelopmentTable from "views/admin/tables/components/DevelopmentTable";
const PreviewLibraryInvoice = (props) => {
  const {
    customerName,
    customerMb,
    customerAddress,
    gameHost,
    modeOfTranscation,
    date,
    _id,
    KeptDays,
    depositAmount,
    rentAmount,
    returnDate,
    checkOutDate,
    products,
    status,
    rentPerDayAmount
  } = props.data;
  console.log(props)
  return (
    <div className="flex justify-center">
      <div className=" container mt-3 rounded-primary bg-white p-5 dark:border-navy-900 dark:bg-navy-800 md-max:text-base">
        <div className="flex justify-center">
          <img src={logo} className="h-20 p-2" />
        </div>
        <div className="mt-4 text-6xl font-semibold text-brand-500">
          Invoice
        </div>
        <div className="mt-5 flex flex-wrap justify-between ">
          <div>
            <span className="text-xl font-semibold text-navy-800  dark:text-white">
              Invoice For:
            </span>
            <br />
            <div className="font-medium text-navy-700 dark:text-gray-500 ">
              {customerName}
              <br />
              {customerMb}
              <br />
              {customerAddress}
            </div>
          </div>
          <div>
            <span className="text-xl font-semibold text-navy-800 dark:text-white">
              Date:
            </span>
            <br />
            <div className="font-medium text-navy-700 dark:text-gray-500">
              {returnDate}
              <br />
            </div>
            <span className="text-xl font-semibold text-navy-800 dark:text-white">
              Mode of Transcation:
            </span>
            <br />
            <div className="font-medium text-navy-700 dark:text-gray-500">
              {modeOfTranscation}
              <br />
            </div>
          </div>

          <div className="">
            <span className="text-xl font-semibold  text-navy-800 dark:text-white">
              Invoice Number:
            </span>
            <br />
            <div className="font-medium text-navy-700 dark:text-gray-500">
              {_id || "#154254252"}
              <br />
            </div>
            <span className="text-xl font-semibold text-navy-800 dark:text-white">
              Payable to:
            </span>
            <br />
            <div className="font-medium text-navy-700 dark:text-gray-500">
              {gameHost}
              <br />
            </div>
          </div>
        </div>
        <div className="m-[-15px] mt-4">
        {status==='CHECKOUT' ? 
          <DevelopmentTable
            columnsData={[
              {
                Header: "Products",
                accessor: "products",
              },
              {
                Header: "Date of Issue",
                accessor: "checkOutDate",
              },
              // {
              //   Header: "Date of Returning",
              //   accessor: "returnDate",
              // },
              {
                Header: "Amount Deposit",
                accessor: "depositAmount",
              },
              // {
              //   Header: "Number of Days",
              //   accessor: "KeptDays",
              // },
              {
                Header: "Rent/Day",
                accessor: "rentPerDayAmount",
              },
              // {
              //   Header: "Rent",
              //   accessor: "rentAmount",
              // },
              // {
              //   Header: "Returning Amount",
              //   accessor: "return",
              // },
            ]}
            tableData={[
              {
                products: products.map(elem=>elem.name).join(','),
                checkOutDate: checkOutDate,
                returnDate: returnDate,
                depositAmount: depositAmount,
                KeptDays: KeptDays,
                rentPerDayAmount:rentPerDayAmount,
                rentAmount: rentAmount,
                return: props.data.returnAmount,
              },
            ]}
            tableTitle={"Details"}
            titleColor={"text-brand-500"}
          />
        : 
          <DevelopmentTable
            columnsData={[
              {
                Header: "Products",
                accessor: "products",
              },
              {
                Header: "Date of Issue",
                accessor: "checkOutDate",
              },
              {
                Header: "Date of Returning",
                accessor: "returnDate",
              },
              {
                Header: "Amount Deposit",
                accessor: "depositAmount",
              },
              {
                Header: "Number of Days",
                accessor: "KeptDays",
              },
              {
                Header: "Rent/Day",
                accessor: "rentPerDayAmount",
              },
              {
                Header: "Rent",
                accessor: "rentAmount",
              },
              {
                Header: "Returning Amount",
                accessor: "return",
              },
            ]}
            tableData={[
              {
                products: products.map(elem=>elem.name).join(','),
                checkOutDate: checkOutDate,
                returnDate: returnDate,
                depositAmount: depositAmount,
                KeptDays: KeptDays,
                rentPerDayAmount:rentPerDayAmount,
                rentAmount: rentAmount,
                return: props.data.returnAmount,
              },
            ]}
            tableTitle={"Details"}
            titleColor={"text-brand-500"}
          />
        }
          <div className="mr-4  text-right text-navy-900 dark:text-white">
            <span className="font-medium">Subtotal : </span>
            <span className="font-semibold">Rs {status === 'CHECKOUT'? depositAmount:rentAmount}</span>
          </div>
        </div>
        <div className="mt-[31px] flex flex-wrap justify-between border-t text-navy-900 dark:border-navy-900 dark:text-white md-max:text-sm">
          <div className=" mt-4 font-semibold">Notes :</div>
          <div className="mt-4  mr-2 text-right md-max:text-sm ">
            {/* <span className="font-medium">Subtotal : </span>
            <span className="font-semibold">Rs {rentAmount}</span>
            <br /> */}
            {/* <span className="font-medium">Adjustments ({discountName}) : </span>
            <span className="font-semibold">
              - Rs {Math.abs(discountAmount)}
            </span> */}
            <div className="mt-2  text-2xl font-bold text-brand-500 dark:border-navy-900 md-max:text-xl">
              Rs {status === 'CHECKOUT'? depositAmount:rentAmount} 
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewLibraryInvoice;
